// extracted by mini-css-extract-plugin
export var pillWrapper = "_or-0";
export var showOverflow = "_or-1";